import {CSSResult, html, LitElement, PropertyValues, TemplateResult, unsafeCSS} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import styles from './article-in-cart-banner.scss';
import basketCheck from '@breuni-ui/bdk/dist/design-tokens/images/icons/o-ic-24_basket-check.svg';
import {addPresentationToIcon} from "../icon/icon-accessibility.js";

@customElement("ents-article-in-cart-banner")
export class ArticleInCartBanner extends LitElement {
  @property({type: String, attribute: "mandanted-host"})
  private mandantedHost = "";
  @property({type: Number, attribute: "syan", reflect: false})
  private syan = 0;
  @property({type: String, attribute: "color-id", reflect: false})
  private colorId = "";
  @property({type: String, reflect: false})
  text = "";
  private articlesInCart: ArticlePosition[] = [];
  @state() private visible = false;

  static get styles(): CSSResult {
    return unsafeCSS(styles);
  }

  private readonly shouldRenderBanner = (syan: number, colorId: string | undefined) => {
    if (colorId) {
      this.visible = this.articlesInCart.some(article => article.colorId === colorId);
    } else {
      this.visible = this.articlesInCart.some(article => article.syan === syan);
    }
  };

  public updated(changedProperties: PropertyValues) {
    super.updated(changedProperties);
    if (changedProperties.has("syan")) {
      this.loadArticlesInCart();
    }
    if (changedProperties.has("colorId")) {
      this.shouldRenderBanner(this.syan, this.colorId);
    }
  }

  loadArticlesInCart() {
    const cartPositionsUrl = `${this.mandantedHost}kauf/api/warenkorb/positionen`;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 500);
    fetch(cartPositionsUrl, {signal: controller.signal})
      .then(response => response.json())
      .then(this.mapCartPositions.bind(this))
      .catch(() => {
          console.error("Failed to load cart positions");
      })
      .finally(() => {
        clearTimeout(timeoutId);
        this.shouldRenderBanner(this.syan, this.colorId);
      });
  }

  mapCartPositions(data: CartPositions) {
    this.articlesInCart = data.positionen.map(
      position => ({
        syan: position.syan,
        colorId: position.farbId
      })
    );
  }

  protected render(): TemplateResult {
    if (!this.visible) {
      return html``;
    } else {
      return html`
        <div class="ents-article-in-cart-banner bdk-alert"
             variant="neutral-light"
             data-test-ents-article-in-cart-banner>
          ${addPresentationToIcon(basketCheck())}
          <div class="bdk-text-s ents-article-in-cart-banner__text">${this.text}</div>
        </div>
      `;
    }
  }
}
